import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Location } from '@angular/common';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-privacy-policy-page',
  standalone: true,
  imports: [TranslocoDirective, TranslocoPipe, ButtonComponent],
  templateUrl: './privacy-policy-page.component.html',
  styleUrl: './privacy-policy-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyPageComponent {
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
